import { useAuth0 } from "@auth0/auth0-react";
import { UserManagement_V1 } from "@rw1/auto-generated-clients";
import { useAppConfig, useEnvConfig } from "rwo-react";
import { setAccessTokenProvider } from "./accessTokenProvider";
import { joinUrl } from ".";

let userManagementClientV1:
  | UserManagement_V1.UserManagementClientV1
  | undefined;

export const useUserManagementServiceV1 =
  (): UserManagement_V1.UserManagementClientV1 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    userManagementClientV1 ??= userManagementClientV1 =
      new UserManagement_V1.UserManagementClientV1(
        joinUrl(backendAddress, config["UserManagementApiSuffix"])
      );
    setAccessTokenProvider(userManagementClientV1, getAccessTokenSilently);

    return userManagementClientV1;
  };
